export const containerTypesLabel = {
  '20DC': "20'DC",
  '20HC': "20'HC",
  '20RF': "20'RF",
  '40DC': "40'DC",
  '40HC': "40'HC",
  '40RF': "40'RF",
  '40OT': "40'OT",
  '40FR': "40'FR",
  '45HC': "45'HC",
};

export const formatContainerType = (containerType?: keyof typeof containerTypesLabel) => {
  if (!containerType) {
    return '';
  }

  return containerTypesLabel[containerType];
};

export const formatContainerPlace = (container: any) => {
  if (!container || !container.block || !container.row) {
    return '';
  }

  const slot = container.slot || '?';
  const tier = container.tier || '?';

  return `${container.block}-${container.row}-${slot}-${tier}`;
};
